const s = {
  'next': '下一步',
  'prev': '上一步',
  'select...': '选择',
  'brand': '品牌',
  'select a date': '选择日期',
  'select hour': '选择时间',
  'day': '日',
  'time': '时间',
  'location': '地点',
  'your data': '您的数据',
  'date and time': '日期和时间',
  'num people': '人数',
  'err num people': '请选择人数',
  'workshop list': '工作坊列表',
  'signup': '登记',

  'first name': '名',
  'last name': '姓',
  'name': '名称',
  'appointment day': '预约日',
  'email': '电子邮件',
  'phone': '电话',
  'phone_scemi': '电话',
  'phone_scemi_placeholder': '333 12345678',
  'prefix_scemi_placeholder': '例如 +39',
  'whatsapp': 'WhatsApp',
  'appointment type': '预约类型',
  'preferred contact': '首选联系方式',
  'preferred language': '首选语言',
  'product category': '产品类别',
  'notes': '说明',
  'subscribe to newsletter': 'Subscribe to newsletter',
  'slot unavailable': '所选时间已不可用',
  'choose another time slot': 'Select another time slot',
  'confirm': '确认',
  'sending': '正在发送',
  'appointment confirmed': '感谢您的预约！<br> 您很快就将收到一封确认电子邮件',

  'onsite': '现场',
  'online': '在线',

  'italian': '意大利文',
  'english': '英文',
  'french': '法文',
  'chinese': '中文',
  'russian': '俄文',
  'japanese': '日文',
  'korean': '韩文',

  'Abbigliamento Bambino': '童装',
  'Abbigliamento Donna': '女装',
  'Abbigliamento Uomo': '男装',
  'Accessori': '配件',
  'Arredamento': '室内设计',
  'Borse': '箱包配饰',
  'Calzature': '鞋类',
  'Calzature Donna': '女鞋',
  'Calzature Uomo': '男装鞋',
  'Fragranze': '香水',
  'Gioielleria': '珠宝首饰',
  'Occhiali Da Sole': '眼镜',
  'Orologi': '手表',
  'Pelletteria': 'Leather goods',
  'Pellicceria': 'Fur Goods',

  'fill all fields': '必填项',
}

export default s;